module.exports = __webpack_public_path__ + "img/TeamedUp4.3e1bfb62.png";